import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Doctor APIs
//TODO: Doctor APIs
//  Doctor Create
export const addDoctorAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}add-doctor`, data, headers);
};
//  Doctor Update
export const updateDoctorAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}update-doctor`, data, headers);
};
//  Doctor Review
export const reviewDoctorAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}review-doctor`, data, headers);
};
//  Doctor List
export const getDoctorListAPI = async () => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-doctor`, headers);
};
//  Doctor Detail
export const getDoctorDetailAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}doctor-by-id`,  data, headers );
}; 
//  Doctor Slot Create
export const createDoctorSlotAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}add-doctor-slot`,  data, headers );
};  
//  Get Doctor Slot
export const getDoctorSlotAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}get-doctor-slot`,  data, headers );
};  
//  Remove CLinic 
export const removeClinicAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}remove-clinic`,  data, headers );
};  
export const refferalDetailAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}referral-details`,  data, headers );
};  
// export const createDoctorSlotOfflineAPI = async (data) => {
//   const headers = createFormHeaders()
//   return await axios.post(`${BASE_URL}add-offline-doctor-slot`,  data, headers );
// }; 
export const createDoctorSlotOfflineAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}add-clinic`,  data, headers );
}; 
export const getZipDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-state-district`, data,headers);
};
export const createMultipleClinicOfflineAPI = async (data) => {
  const headers = createFormHeaders()
  return await axios.post(`${BASE_URL}create-multiple-clinic`,  data, headers );
}; 